/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AdminSubscriptionPaymentResponse } from './admin-subscription-payment-response';
// May contain unused imports in some cases
// @ts-ignore
import { DietaryTargetsResponse } from './dietary-targets-response';
// May contain unused imports in some cases
// @ts-ignore
import { PlanOptionSubscriptionDetailResponse } from './plan-option-subscription-detail-response';
// May contain unused imports in some cases
// @ts-ignore
import { SubscriptionActionResponse } from './subscription-action-response';

/**
 * 
 * @export
 * @interface AdminSubscriptionDetailResponse
 */
export interface AdminSubscriptionDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSubscriptionDetailResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'status'?: AdminSubscriptionDetailResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'partnerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'partnerName'?: string;
    /**
     * 
     * @type {PlanOptionSubscriptionDetailResponse}
     * @memberof AdminSubscriptionDetailResponse
     */
    'planOption'?: PlanOptionSubscriptionDetailResponse;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminSubscriptionDetailResponse
     */
    'remainingDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSubscriptionDetailResponse
     */
    'daysToStart'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSubscriptionDetailResponse
     */
    'assignedDays'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSubscriptionDetailResponse
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'cancellationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'invoiceId'?: string;
    /**
     * 
     * @type {Array<SubscriptionActionResponse>}
     * @memberof AdminSubscriptionDetailResponse
     */
    'actions'?: Array<SubscriptionActionResponse>;
    /**
     * 
     * @type {DietaryTargetsResponse}
     * @memberof AdminSubscriptionDetailResponse
     */
    'dietaryTargets'?: DietaryTargetsResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSubscriptionDetailResponse
     */
    'deliveryDays'?: Array<AdminSubscriptionDetailResponseDeliveryDaysEnum>;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'balanceType'?: AdminSubscriptionDetailResponseBalanceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSubscriptionDetailResponse
     */
    'cancellable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDetailResponse
     */
    'discountCode'?: string;
    /**
     * 
     * @type {AdminSubscriptionPaymentResponse}
     * @memberof AdminSubscriptionDetailResponse
     */
    'payment'?: AdminSubscriptionPaymentResponse;
}

export const AdminSubscriptionDetailResponseStatusEnum = {
    Active: 'ACTIVE',
    Future: 'FUTURE',
    Past: 'PAST',
    Cancelled: 'CANCELLED'
} as const;

export type AdminSubscriptionDetailResponseStatusEnum = typeof AdminSubscriptionDetailResponseStatusEnum[keyof typeof AdminSubscriptionDetailResponseStatusEnum];
export const AdminSubscriptionDetailResponseDeliveryDaysEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type AdminSubscriptionDetailResponseDeliveryDaysEnum = typeof AdminSubscriptionDetailResponseDeliveryDaysEnum[keyof typeof AdminSubscriptionDetailResponseDeliveryDaysEnum];
export const AdminSubscriptionDetailResponseBalanceTypeEnum = {
    Actual: 'ACTUAL',
    Virtual: 'VIRTUAL'
} as const;

export type AdminSubscriptionDetailResponseBalanceTypeEnum = typeof AdminSubscriptionDetailResponseBalanceTypeEnum[keyof typeof AdminSubscriptionDetailResponseBalanceTypeEnum];


